// Páginas web publicadas (editor.lisual.com/p/...) SIN recorrido 360, por feedID de cámara. Las que tienen 360 de la
// Insta360 van en src/recorrido360/recorridos360.data.js (pestaña Recorrido 360°).
// Armado el 26/10/2026 desde las 249 páginas del Editor 2.0 (timelapse/public/pages, lo mismo que lista el panel de Webs):
// por cámara, primero la web de la obra y la de la empresa (armadas a mano) y, si no hay de obra, la más nueva del bot;
// sin pruebas, demos ni versiones viejas. tipo: obra | empresa | bot.
export const WEBS_POR_FEED = {
 "fe0ykvvkw69r": [
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  },
  {
   "titulo": "HBD-Virazon · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-01",
   "url": "https://editor.lisual.com/p/UI38RT"
  }
 ],
 "fexulctzvnkd": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  },
  {
   "titulo": "HBD SRL-San Fernando- Ingreso — Lisual",
   "tipo": "bot",
   "actualizada": "2026-04-29",
   "url": "https://editor.lisual.com/p/OV8YK9"
  }
 ],
 "limcxz11yhm0": [
  {
   "titulo": "ChronosGroup · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/C1G9A7"
  }
 ],
 "fefxpdi8njmv": [
  {
   "titulo": "CAMPAMENTO — Lisual",
   "tipo": "bot",
   "actualizada": "2026-05-13",
   "url": "https://editor.lisual.com/p/Z0CKDG"
  }
 ],
 "fexfwx0dwzhy": [
  {
   "titulo": "Lagos del Golf 468 — GSG Arquitectura",
   "tipo": "obra",
   "actualizada": "2026-07-08",
   "url": "https://editor.lisual.com/p/gsg"
  }
 ],
 "li1qovd9p0sj": [
  {
   "titulo": "Roca Open · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-24",
   "url": "https://editor.lisual.com/p/G0KRZ7"
  }
 ],
 "fe0zaczqmmmq": [
  {
   "titulo": "P_geo030 Chubut · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-05-31",
   "url": "https://editor.lisual.com/p/8SB7WJ"
  }
 ],
 "fecwegfgu0nf": [
  {
   "titulo": "Vista-CBN-1 — Lisual",
   "tipo": "bot",
   "actualizada": "2026-05-30",
   "url": "https://editor.lisual.com/p/3J0Y0A"
  }
 ],
 "feuvssnmyne6": [
  {
   "titulo": "Grupo Upgrade - River Park — Lisual",
   "tipo": "bot",
   "actualizada": "2026-05-30",
   "url": "https://editor.lisual.com/p/HJZXSC"
  }
 ],
 "fesgt6offjg4": [
  {
   "titulo": "UNILEVER-PILAR — Lisual",
   "tipo": "bot",
   "actualizada": "2026-05-30",
   "url": "https://editor.lisual.com/p/GKX2OF"
  }
 ],
 "livuxvpcvubt": [
  {
   "titulo": "Estudio TYT · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-03",
   "url": "https://editor.lisual.com/p/A5EN15"
  }
 ],
 "lixe6yq0ah25": [
  {
   "titulo": "Expo Investors · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-05",
   "url": "https://editor.lisual.com/p/AM23UM"
  }
 ],
 "lih1lc2eht60": [
  {
   "titulo": "LOGICOM · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-18",
   "url": "https://editor.lisual.com/p/J47MR9"
  }
 ],
 "fezqehmsd4hv": [
  {
   "titulo": "Torre II · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-02",
   "url": "https://editor.lisual.com/p/3YINBM"
  }
 ],
 "licyh5jnften": [
  {
   "titulo": "ARQ LOTE · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-02",
   "url": "https://editor.lisual.com/p/FGYE5B"
  }
 ],
 "limurvyhcmrm": [
  {
   "titulo": "Godai la barra 2 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-03",
   "url": "https://editor.lisual.com/p/VZ9JCJ"
  }
 ],
 "feichw6jmpmq": [
  {
   "titulo": "Puerta 11 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-13",
   "url": "https://editor.lisual.com/p/CQB8E8"
  }
 ],
 "li07vb6ib2qn": [
  {
   "titulo": "ALGARROBOS G&A · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-10",
   "url": "https://editor.lisual.com/p/WOZYMA"
  }
 ],
 "lixtpsip5juw": [
  {
   "titulo": "Hotel Sector 5;6;7;8 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-21",
   "url": "https://editor.lisual.com/p/K2V01U"
  }
 ],
 "fe6nydzzsgvk": [
  {
   "titulo": "Puerta 3 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-17",
   "url": "https://editor.lisual.com/p/740WMY"
  }
 ],
 "liwkb09qt3j6": [
  {
   "titulo": "AeroPro · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-25",
   "url": "https://editor.lisual.com/p/7CU124"
  }
 ],
 "fehkzmpd2bpz": [
  {
   "titulo": "V&V Bravo · Nuestras obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-24",
   "url": "https://editor.lisual.com/p/vyvbravo"
  }
 ],
 "febmnqtdpirm": [
  {
   "titulo": "CAM3 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-17",
   "url": "https://editor.lisual.com/p/SMJTVF"
  }
 ],
 "li349j33slsw": [
  {
   "titulo": "GRUPO EC · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-18",
   "url": "https://editor.lisual.com/p/7Y8P4N"
  }
 ],
 "fevutsxdzwci": [
  {
   "titulo": "PGG · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-18",
   "url": "https://editor.lisual.com/p/T7EBAC"
  }
 ],
 "femysnbosow7": [
  {
   "titulo": "Veronia · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-18",
   "url": "https://editor.lisual.com/p/3G78XS"
  }
 ],
 "lihcrh3mswi1": [
  {
   "titulo": "MyR · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-19",
   "url": "https://editor.lisual.com/p/X2QJOX"
  }
 ],
 "livy8sdvnt02": [
  {
   "titulo": "ALBEH ARQUITECTURA · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-19",
   "url": "https://editor.lisual.com/p/Z2W06S"
  }
 ],
 "liyerzofykxb": [
  {
   "titulo": "Kevin kehler · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-21",
   "url": "https://editor.lisual.com/p/I1PLWH"
  }
 ],
 "febatvpi4v1d": [
  {
   "titulo": "TERMINADO - NAVE DPYM APE · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-22",
   "url": "https://editor.lisual.com/p/F9ZA2K"
  }
 ],
 "lite9jrx7u0j": [
  {
   "titulo": "RR · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-23",
   "url": "https://editor.lisual.com/p/NTXSUR"
  }
 ],
 "liig1dce6r05": [
  {
   "titulo": "ZP · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-23",
   "url": "https://editor.lisual.com/p/MAMAD9"
  }
 ],
 "liot7ctlce8c": [
  {
   "titulo": "Donato Blvd. Ameghino 771 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-06-25",
   "url": "https://editor.lisual.com/p/EEORB5"
  }
 ],
 "feyrwp3lfayi": [
  {
   "titulo": "Proyecto Norte 2 - Hilton Garden Inn Salta · Reporte de Avan",
   "tipo": "bot",
   "actualizada": "2026-06-30",
   "url": "https://editor.lisual.com/p/3CDYBW"
  }
 ],
 "fejeke0popcg": [
  {
   "titulo": "Proyecto Norte 1 - Hilton Garden Inn Salta · Reporte de Avan",
   "tipo": "bot",
   "actualizada": "2026-06-30",
   "url": "https://editor.lisual.com/p/V2I6WU"
  }
 ],
 "lipbhlhqrnvf": [
  {
   "titulo": "Planta Girasol · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-30",
   "url": "https://editor.lisual.com/p/OVD889"
  }
 ],
 "li4h4b3dwtpa": [
  {
   "titulo": "Obra Virasoro — Planta Mass Timber | Cambium",
   "tipo": "obra",
   "actualizada": "2026-07-03",
   "url": "https://editor.lisual.com/p/obravirasoro"
  },
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "litl3f9f7wj5": [
  {
   "titulo": "Obra Virasoro — Planta Mass Timber | Cambium",
   "tipo": "obra",
   "actualizada": "2026-07-03",
   "url": "https://editor.lisual.com/p/obravirasoro"
  }
 ],
 "liu2s09fj2hn": [
  {
   "titulo": "Obra Virasoro — Planta Mass Timber | Cambium",
   "tipo": "obra",
   "actualizada": "2026-07-03",
   "url": "https://editor.lisual.com/p/obravirasoro"
  }
 ],
 "lilhud4hbqv5": [
  {
   "titulo": "Carmel · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-07",
   "url": "https://editor.lisual.com/p/QDXRAG"
  }
 ],
 "liqvozse11yv": [
  {
   "titulo": "Lagos del Golf 468 — GSG Arquitectura",
   "tipo": "obra",
   "actualizada": "2026-07-08",
   "url": "https://editor.lisual.com/p/gsg"
  }
 ],
 "li86zi5i91wd": [
  {
   "titulo": "Casa SM2 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-10",
   "url": "https://editor.lisual.com/p/BG71FR"
  }
 ],
 "fe2j7xazbyti": [
  {
   "titulo": "Cavego · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-10",
   "url": "https://editor.lisual.com/p/JIQRQN"
  }
 ],
 "ferw5klhqmat": [
  {
   "titulo": "The collectiion 2 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-14",
   "url": "https://editor.lisual.com/p/PFI04H"
  }
 ],
 "li2zfewfjnhr": [
  {
   "titulo": "ANCHORENA 02 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-17",
   "url": "https://editor.lisual.com/p/WJTBBW"
  }
 ],
 "fefdfmh834vu": [
  {
   "titulo": "Via viva exterior - Zaracho · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-20",
   "url": "https://editor.lisual.com/p/6WYMYS"
  }
 ],
 "liwxgti5bv5z": [
  {
   "titulo": "TORRESPAINE_1 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-07-20",
   "url": "https://editor.lisual.com/p/ODFQPR"
  }
 ],
 "fe5zapgb75uo": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  }
 ],
 "feanqdo62zmy": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  }
 ],
 "fenaxxkio2k7": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  }
 ],
 "fevfgtgiqsll": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  }
 ],
 "feyhysfmkr7b": [
  {
   "titulo": "Obra San Fernando · HBD Construcciones — en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/hbdsanfernando"
  },
  {
   "titulo": "HBD Construcciones · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-23",
   "url": "https://editor.lisual.com/p/hbd"
  }
 ],
 "feteemzh0rip": [
  {
   "titulo": "Uniview · Obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-29",
   "url": "https://editor.lisual.com/p/uniview"
  }
 ],
 "feyp7skefp6c": [
  {
   "titulo": "Uniview · Obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-29",
   "url": "https://editor.lisual.com/p/uniview"
  }
 ],
 "fehcfoipxhje": [
  {
   "titulo": "V&V Bravo · Nuestras obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-24",
   "url": "https://editor.lisual.com/p/vyvbravo"
  }
 ],
 "fepxk4pkcuzy": [
  {
   "titulo": "V&V Bravo · Nuestras obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-24",
   "url": "https://editor.lisual.com/p/vyvbravo"
  }
 ],
 "li0ue32fx17s": [
  {
   "titulo": "Sierra Viva · Tandil — Un country urbano",
   "tipo": "obra",
   "actualizada": "2026-07-29",
   "url": "https://editor.lisual.com/p/sierraviva"
  }
 ],
 "limee07qeus1": [
  {
   "titulo": "Siete Setenta · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-29",
   "url": "https://editor.lisual.com/p/sietesetenta"
  },
  {
   "titulo": "Santos Dumont 3724 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-22",
   "url": "https://editor.lisual.com/p/8Z0L8Q"
  }
 ],
 "fenocixnjwqy": [
  {
   "titulo": "TermoPlak · Obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-28",
   "url": "https://editor.lisual.com/p/termoplak"
  }
 ],
 "li0f05pxloof": [
  {
   "titulo": "TermoPlak · Obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-28",
   "url": "https://editor.lisual.com/p/termoplak"
  }
 ],
 "lig3ki007j1r": [
  {
   "titulo": "TermoPlak · Obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-07-28",
   "url": "https://editor.lisual.com/p/termoplak"
  }
 ],
 "li0dohtoaotl": [
  {
   "titulo": "Siete Setenta · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-29",
   "url": "https://editor.lisual.com/p/sietesetenta"
  }
 ],
 "lierjeze2kqf": [
  {
   "titulo": "Siete Setenta · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-29",
   "url": "https://editor.lisual.com/p/sietesetenta"
  }
 ],
 "linkm71jxuns": [
  {
   "titulo": "Siete Setenta · Obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-07-29",
   "url": "https://editor.lisual.com/p/sietesetenta"
  }
 ],
 "li8u0m8n71tk": [
  {
   "titulo": "Casa Origen · Amarras 438, Puertos — Obra en vivo | Rakentaa",
   "tipo": "obra",
   "actualizada": "2026-08-27",
   "url": "https://editor.lisual.com/p/amarras438"
  }
 ],
 "fep8uc2wkty9": [
  {
   "titulo": "San Martín · Edifizzi en vivo",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/EDIFFIZI"
  },
  {
   "titulo": "San Martín · Edifizzi · Vicente López",
   "tipo": "obra",
   "actualizada": "2026-07-31",
   "url": "https://editor.lisual.com/p/sanmartin"
  }
 ],
 "licitaciones": [
  {
   "titulo": "Calendario de contenido · Agosto — Lagos del Golf 468 · GSG ",
   "tipo": "obra",
   "actualizada": "2026-08-02",
   "url": "https://editor.lisual.com/p/chediack-obras"
  }
 ],
 "fe2chvqvoura": [
  {
   "titulo": "Racaval - Teatro · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-10",
   "url": "https://editor.lisual.com/p/H88R5D"
  }
 ],
 "liepmxnp3wm3": [
  {
   "titulo": "GENERAL · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-13",
   "url": "https://editor.lisual.com/p/13QRGO"
  }
 ],
 "lieguvaintf0": [
  {
   "titulo": "DUM · Distrito Urbano Mall — San Justo | J.P. Stella",
   "tipo": "obra",
   "actualizada": "2026-08-14",
   "url": "https://editor.lisual.com/p/dum"
  },
  {
   "titulo": "J.P. Stella · Central de monitoreo de obras",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/stella"
  },
  {
   "titulo": "J.P. Stella · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/stellaobras"
  }
 ],
 "likq89c1irdl": [
  {
   "titulo": "DUM · Distrito Urbano Mall — San Justo | J.P. Stella",
   "tipo": "obra",
   "actualizada": "2026-08-14",
   "url": "https://editor.lisual.com/p/dum"
  },
  {
   "titulo": "J.P. Stella · Central de monitoreo de obras",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/stella"
  },
  {
   "titulo": "J.P. Stella · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/stellaobras"
  }
 ],
 "li3w76molwjs": [
  {
   "titulo": "El Nido · el Wavegarden en vivo — Beach & Surf Homes",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/elnido"
  }
 ],
 "fe3hz8shl6ea": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "fed1hqvdo1a3": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "feewsto3qey6": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "fehy5fkfi7uz": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "feiqdguubdfe": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "feracjwqqqho": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "lifbxlb11tzl": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "lixcaj920wga": [
  {
   "titulo": "Belfast · Tablero de obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/belfast"
  },
  {
   "titulo": "Belfast Construction Management · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/belfastobras"
  }
 ],
 "lihfomzulfs5": [
  {
   "titulo": "RR APE IV · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-17",
   "url": "https://editor.lisual.com/p/584BO7"
  }
 ],
 "li5cbxsu9j3h": [
  {
   "titulo": "NEXT - NEUQUEN · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-20",
   "url": "https://editor.lisual.com/p/EBOHYT"
  }
 ],
 "liyejwuj9xi7": [
  {
   "titulo": "Hotel Sector 1:2:3:4 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-21",
   "url": "https://editor.lisual.com/p/9C6LKO"
  }
 ],
 "lidfn3emzvc4": [
  {
   "titulo": "VIBRA OLIVOS 01 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-24",
   "url": "https://editor.lisual.com/p/8S7DE0"
  }
 ],
 "lies7mhohc9w": [
  {
   "titulo": "J.P. Stella · Central de monitoreo de obras",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/stella"
  },
  {
   "titulo": "J.P. Stella · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/stellaobras"
  }
 ],
 "lirtbl5klcqc": [
  {
   "titulo": "J.P. Stella · Central de monitoreo de obras",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/stella"
  },
  {
   "titulo": "J.P. Stella · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/stellaobras"
  }
 ],
 "litya96vxi0r": [
  {
   "titulo": "J.P. Stella · Central de monitoreo de obras",
   "tipo": "empresa",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/stella"
  },
  {
   "titulo": "J.P. Stella · Nuestras obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/stellaobras"
  }
 ],
 "lie2wsnau0qi": [
  {
   "titulo": "Corrales estabulados · Estancia El Pegual — Obra en vivo | O",
   "tipo": "obra",
   "actualizada": "2026-08-27",
   "url": "https://editor.lisual.com/p/omivillegas"
  },
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "lig58zd6i1mw": [
  {
   "titulo": "Corrales estabulados · Estancia El Pegual — Obra en vivo | O",
   "tipo": "obra",
   "actualizada": "2026-08-27",
   "url": "https://editor.lisual.com/p/omivillegas"
  },
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "li0niy2zef5y": [
  {
   "titulo": "Obra de Isaac · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-26",
   "url": "https://editor.lisual.com/p/CK2R46"
  }
 ],
 "li1noqn7opyj": [
  {
   "titulo": "La Pista 1270 · Ingeniero Maschwitz — Obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/lapista1270"
  }
 ],
 "liucol396hmh": [
  {
   "titulo": "La Pista 1270 · Ingeniero Maschwitz — Obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/lapista1270"
  }
 ],
 "liz4yzqsqnu3": [
  {
   "titulo": "20dptos alto comedero  · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-08-28",
   "url": "https://editor.lisual.com/p/ZRDPRA"
  }
 ],
 "fe8yfwjoynp3": [
  {
   "titulo": "Rodrigo Eslava · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-23",
   "url": "https://editor.lisual.com/p/G4ON07"
  }
 ],
 "fe88cdixju1n": [
  {
   "titulo": "We Surf Nogales · La obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/nogales"
  }
 ],
 "li9yiscw2qmc": [
  {
   "titulo": "Imach Cohen · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-01",
   "url": "https://editor.lisual.com/p/4V4TL0"
  }
 ],
 "li36hecbqpnz": [
  {
   "titulo": "Hormetal · Lote 25 en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/hormetal"
  }
 ],
 "fek0xccfosc5": [
  {
   "titulo": "Royal Village · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-03",
   "url": "https://editor.lisual.com/p/7WQ5N9"
  }
 ],
 "liw8wxcnqpsu": [
  {
   "titulo": "Arcila Arquitectos · Monitoreo de obras",
   "tipo": "obra",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/arcila"
  }
 ],
 "li9kx8crj7lt": [
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "liam4chjgsvq": [
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "liez21nv6ykl": [
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "lirudec68w7x": [
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "lis4g5jtboj5": [
  {
   "titulo": "OMI Construcciones · Central de monitoreo",
   "tipo": "empresa",
   "actualizada": "2026-09-07",
   "url": "https://editor.lisual.com/p/omi"
  }
 ],
 "fej6lkizeelp": [
  {
   "titulo": "VA-RIO IV-CAM01 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-10",
   "url": "https://editor.lisual.com/p/O069G7"
  }
 ],
 "li5j6epwefyn": [
  {
   "titulo": "TAO — Mirá cómo se construye un módulo SIP, en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-26",
   "url": "https://editor.lisual.com/p/tao"
  }
 ],
 "licihw7adyb5": [
  {
   "titulo": "HEON Urbano · Mirá cómo se construye, en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/heon"
  }
 ],
 "li3gwkzcnoli": [
  {
   "titulo": "HGC ARQUITECTOS · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-14",
   "url": "https://editor.lisual.com/p/RQ30UG"
  }
 ],
 "likvffphzl8p": [
  {
   "titulo": "Boschetto Arcos · Belgrano — La obra en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-27",
   "url": "https://editor.lisual.com/p/boschetto"
  }
 ],
 "lihnoixqoek5": [
  {
   "titulo": "CSHA Canning · La obra en vivo — Estudio ABS",
   "tipo": "obra",
   "actualizada": "2026-09-29",
   "url": "https://editor.lisual.com/p/circulohebreo"
  },
  {
   "titulo": "Estudio ABS · Las obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-14",
   "url": "https://editor.lisual.com/p/abs"
  }
 ],
 "febn1fgqfknk": [
  {
   "titulo": "Estudio ABS · Las obras en vivo",
   "tipo": "obra",
   "actualizada": "2026-09-14",
   "url": "https://editor.lisual.com/p/abs"
  }
 ],
 "likacshwfojn": [
  {
   "titulo": "BD Constructora · Obra Puerto Madero",
   "tipo": "obra",
   "actualizada": "2026-10-06",
   "url": "https://editor.lisual.com/p/bdmadero"
  }
 ],
 "liq2sjwur1cr": [
  {
   "titulo": "Geovial · Obra Comodoro Rivadavia",
   "tipo": "obra",
   "actualizada": "2026-10-15",
   "url": "https://editor.lisual.com/p/geovial"
  }
 ],
 "lieqgbpjnlao": [
  {
   "titulo": "Paseo 52 · Canning · La obra en tiempo real",
   "tipo": "obra",
   "actualizada": "2026-09-30",
   "url": "https://editor.lisual.com/p/paseo52"
  }
 ],
 "lifmhr94ink7": [
  {
   "titulo": "Paseo 52 · Canning · La obra en tiempo real",
   "tipo": "obra",
   "actualizada": "2026-09-30",
   "url": "https://editor.lisual.com/p/paseo52"
  }
 ],
 "fe7jrzg87zjw": [
  {
   "titulo": "Ayres Desarrollos TM1 · Reporte de Avance — Lisual",
   "tipo": "bot",
   "actualizada": "2026-09-21",
   "url": "https://editor.lisual.com/p/6QA82L"
  }
 ],
 "lir6g6kpxywv": [
  {
   "titulo": "Esquina Gaona · La obra en vivo — ABS Estudio",
   "tipo": "obra",
   "actualizada": "2026-10-05",
   "url": "https://editor.lisual.com/p/absgaona"
  }
 ],
 "li87guso9a09": [
  {
   "titulo": "FAE · las obras en vivo — Las Toscas y Spegazzini",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/fae"
  }
 ],
 "likhzi67h86h": [
  {
   "titulo": "FAE · las obras en vivo — Las Toscas y Spegazzini",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/fae"
  }
 ],
 "li1w6t04ek2p": [
  {
   "titulo": "INAP · las obras en vivo — Córdoba",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/inap"
  }
 ],
 "lix0uoaz2guz": [
  {
   "titulo": "INAP · las obras en vivo — Córdoba",
   "tipo": "obra",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/inap"
  }
 ],
 "ligl16dgnd68": [
  {
   "titulo": "Isola Construcciones · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/N0XVKG"
  }
 ],
 "li6qpx2axgi4": [
  {
   "titulo": "Viviendas Nec · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/VNEC01"
  }
 ],
 "lill7phri8vl": [
  {
   "titulo": "Viviendas Nec · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/VNEC01"
  }
 ],
 "lixfuyz1n5bh": [
  {
   "titulo": "Viviendas Nec · las obras en vivo",
   "tipo": "bot",
   "actualizada": "2026-10-01",
   "url": "https://editor.lisual.com/p/VNEC01"
  }
 ],
 "lib54j79dozd": [
  {
   "titulo": "Esteban Echeverría 4230 · Grupo Fralo en vivo",
   "tipo": "obra",
   "actualizada": "2026-10-02",
   "url": "https://editor.lisual.com/p/FRALO"
  }
 ],
 "liny0cbmimth": [
  {
   "titulo": "Esteban Echeverría 4230 · Grupo Fralo en vivo",
   "tipo": "obra",
   "actualizada": "2026-10-02",
   "url": "https://editor.lisual.com/p/FRALO"
  }
 ],
 "li8my8giz1et": [
  {
   "titulo": "Metalúrgica Andrea · las obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-13",
   "url": "https://editor.lisual.com/p/metalurgicaandrea"
  }
 ],
 "lihjyl2tup9h": [
  {
   "titulo": "Metalúrgica Andrea · las obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-13",
   "url": "https://editor.lisual.com/p/metalurgicaandrea"
  }
 ],
 "lijhdg4ng52t": [
  {
   "titulo": "Metalúrgica Andrea · las obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-13",
   "url": "https://editor.lisual.com/p/metalurgicaandrea"
  }
 ],
 "litoiw37fsdc": [
  {
   "titulo": "Metalúrgica Andrea · las obras en vivo",
   "tipo": "empresa",
   "actualizada": "2026-10-13",
   "url": "https://editor.lisual.com/p/metalurgicaandrea"
  }
 ]
};

/** Webs (sin 360) de una cámara, o null. */
export function buscarWebs(feedID) {
  return (feedID && WEBS_POR_FEED[feedID]) || null;
}
